import { ReduxService } from 'dashboard-services/services';

import { copyModalDataStorageActions } from 'actions/modules/dataStorage/list';

export const copyModalInitialState = {
  groupName: undefined,
  oldName: "",
  name: "",
  id: undefined,
  isOpen: false,
  errors: []
}

export default (state = copyModalInitialState, action) => {
  switch (action.type) {
    case copyModalDataStorageActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value, errors: (state.errors || []).filter(e => !String(e.field).startsWith(`${action.name}`)) })
      }
      return state;
    }
    case copyModalDataStorageActions.SET_ERRORS:
      return ReduxService.updateObject(state, { errors: action.errors })
    default:
      return state;
  }
}